import { createBasicSelector } from 'util/redux'
import { selectBase } from './selectBase'

export const selectFuturePhase = createBasicSelector(
  selectBase,
  base => base.futurePhase
)
